export const topbarStrings = {
  selectLocation: 'Seleccionar ubicación',
  searchPlaceholder: 'Buscar pacientes, citas...',
  notificationsLabel: 'Notificaciones',
  defaultSpecialty: 'Médico',
  openMenuLabel: 'Abrir menú',
  noLocations: 'Sin ubicaciones configuradas',
  addLocation: 'Añadir ubicación',
} as const

export const globalLoadingStrings = {
  loadingLabel: 'Cargando…',
} as const

export const sidebarStrings = {
  navTodayLabel: 'Hoy',
  navClinicalLabel: 'Trabajo Clínico',
  navAdminLabel: 'Administración',
  navDashboard: 'Dashboard',
  navAgenda: 'Agenda',
  navPatients: 'Pacientes',
  navProtocols: 'Protocolos',
  navBilling: 'Facturación',
  navSettings: 'Ajustes',
  defaultSpecialty: 'Médico',
  defaultName: 'Médico',
  userMenuLabel: 'Menú de usuario',
  userMenuSettings: 'Ajustes',
  userMenuSignOut: 'Cerrar sesión',
} as const
